import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scheduledTime", "customTimeInput", "form", "comment", "dropdown"]

  static times = {
    tomorrow: {
      daysOffset: 1,
      hour: 8,
      minute: 0,
      displayFormat: "Tomorrow at 8AM"
    },
    nextWeek: {
      daysOffset: 7,
      hour: 8,
      minute: 0,
      displayFormatFn: (date) => {
        const weekdayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
        return `${weekdayNames[date.getDay()]} at 8AM`
      }
    }
  }


  scheduleTomorrow(event) {
    event.preventDefault()
    this.scheduleForPreset('tomorrow')
    this.submitForm()
  }

  scheduleNextWeek(event) {
    event.preventDefault()
    this.scheduleForPreset('nextWeek')
    this.submitForm()
  }

  scheduleForPreset(presetKey) {
    const preset = this.constructor.times[presetKey]
    if (!preset) return

    const date = new Date()
    date.setDate(date.getDate() + preset.daysOffset)
    date.setHours(preset.hour, preset.minute, 0, 0)

    this.scheduleFor(date)
  }

  submitCustomSchedule(event) {
    event.preventDefault()

    const dateTimeStr = this.customTimeInputTarget.value

    const scheduledDateTime = new Date(dateTimeStr)
    if (isNaN(scheduledDateTime.getTime())) {
      alert("Invalid date or time format")
      return
    }

    if (!this.commentTarget.value) {
      alert("Please fill out a comment before scheduling")
      return
    }
    this.scheduleFor(scheduledDateTime)
    this.submitForm()
    this.hideDropdown()
  }

  hideDropdown() {
    const dropdownInstance = bootstrap.Dropdown.getInstance(this.dropdownTarget)
    if (dropdownInstance) dropdownInstance.hide()
  }

  scheduleFor(dateTime) {
    this.scheduledTimeTarget.value = dateTime.toISOString()

  }

  submitForm() {
    this.formTarget.requestSubmit()
    this.formTarget.reset();
  }
}
